import styled from 'styled-components';

interface Props {
  thumbnail: string;
}

const VideoStyles = styled.div<Props>`
  border-radius: 12px;
  max-width: 173px;
  max-height: 120px;
  height: 120px;
  width: 173px;
  background-image: url(${({ thumbnail }: Props): string => `${thumbnail}`});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export default VideoStyles;
